import { createAsyncThunk } from '@reduxjs/toolkit'
import Playlist from './playlist-model'
import {
  delete_playlist,
  load_playlists,
  store_playlist,
} from './playlist-service'

export const LoadPlaylistsAsync = createAsyncThunk<any, any>(
  'composer/load/playlist',
  async (params: { uid: string }) => {
    return await load_playlists(params)
  },
)

export const CreatePlaylistAsync = createAsyncThunk<any, any>(
  'composer/create/playlist',
  async (params: Playlist) => {
    return await store_playlist(params)
  },
)

export const DeletePlaylistAsync = createAsyncThunk<any, any>(
  'composer/delete/playlist',
  async (params) => {
    return await delete_playlist(params)
  },
)
